function activateGallery(gallery,target){
  var panels=gallery.querySelectorAll('[data-gallery-panel]');
  var thumbs=gallery.querySelectorAll('[data-gallery-thumb]');
  var found=false;
  panels.forEach(function(panel){if(panel.id===target)found=true});
  if(!found)return;
  panels.forEach(function(panel){panel.hidden=panel.id!==target});
  thumbs.forEach(function(thumb){thumb.setAttribute('aria-pressed',String(thumb.dataset.galleryTarget===target))});
}
var initializedBuyBoxes=new WeakSet();
var initializedGalleries=new WeakSet();
function initBuyBox(box){
  if(initializedBuyBoxes.has(box))return;
  initializedBuyBoxes.add(box);
  var qty=box.querySelector('[name="quantity"]');
  var variant=box.querySelector('[data-variant-select]');
  var variantId=box.querySelector('[name="id"]');
  var total=box.querySelector('[data-total]');
  var compare=box.querySelector('[data-compare]');
  var addButton=box.querySelector('[data-purchase-add]');
  var express=box.querySelector('[data-purchase-express]');
  var tiers=box.querySelectorAll('[data-tier]');
  var currency=box.dataset.currency;
  var priceRow=null;
  document.querySelectorAll('[data-product-price]').forEach(function(row){if(row.dataset.productSection===box.dataset.productSection)priceRow=row});
  function money(value){
    try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currency}).format(Number(value)/100)}
    catch(_error){return '—'}
  }
  function syncVariantMedia(){
    var chosen=variant.options[variant.selectedIndex];
    if(!chosen)return;
    if(!chosen.dataset.mediaId)return;
    document.querySelectorAll('[data-product-gallery]').forEach(function(gallery){
      if(gallery.dataset.productSection!==box.dataset.productSection)return;
      var panels=gallery.querySelectorAll('[data-gallery-panel]');
      var selectedPanel=null;
      panels.forEach(function(panel){
        if(panel.dataset.mediaId===chosen.dataset.mediaId)selectedPanel=panel;
      });
      if(!selectedPanel)selectedPanel=panels[0];
      if(selectedPanel)activateGallery(gallery,selectedPanel.id);
    });
  }
  function refresh(){
    var chosen=variant.options[variant.selectedIndex];
    var n=Number(qty.value);
    var validQty=qty.value!==''&&Number.isSafeInteger(n)&&n>=1&&n<=10000;
    qty.setCustomValidity(validQty?'':'Enter a whole quantity from 1 to 10000');
    if(addButton)addButton.disabled=!chosen||chosen.disabled||!validQty;
    if(express)express.hidden=!chosen||chosen.disabled||!validQty;
    if(!chosen){total.textContent='—';compare.textContent='';return}
    variantId.value=chosen.value;
    if(chosen.disabled){total.textContent='—';compare.textContent='';return}
    tiers.forEach(function(button){button.setAttribute('aria-pressed',String(validQty&&(Number(button.dataset.tier)===n||(button.dataset.tier==='3'&&n>3))))});
    var unit=Number(chosen.dataset.price);
    if(!validQty||!Number.isSafeInteger(unit)||unit<0){total.textContent='—';compare.textContent='';return}
    var base=BigInt(unit)*BigInt(n);
    var bps=n>=3?8500n:n>=2?9000n:10000n;
    var discounted=(base*bps+5000n)/10000n;
    if(base>BigInt(Number.MAX_SAFE_INTEGER)){total.textContent='—';compare.textContent='';return}
    total.textContent=money(discounted);
    compare.textContent=n>1?money(base):'';
  }
  function updatePrice(){
    var chosen=variant.options[variant.selectedIndex];
    if(!priceRow||!chosen)return;
    var unit=Number(chosen.dataset.price);
    var was=Number(chosen.dataset.comparePrice);
    if(!Number.isSafeInteger(unit)||unit<0)return;
    var current=priceRow.querySelector('[data-price-current]');
    var compareAt=priceRow.querySelector('[data-price-compare]');
    if(current)current.textContent=money(unit);
    if(compareAt){var show=Number.isSafeInteger(was)&&was>unit;compareAt.hidden=!show;compareAt.textContent=show?money(was):''}
  }
  tiers.forEach(function(button){button.addEventListener('click',function(){qty.value=button.dataset.tier;refresh()})});
  variant.addEventListener('change',function(){refresh();updatePrice();syncVariantMedia()});
  qty.addEventListener('input',refresh);
  refresh();
  syncVariantMedia();
}
function initGallery(gallery){
  if(initializedGalleries.has(gallery))return;
  initializedGalleries.add(gallery);
  var thumbs=gallery.querySelectorAll('[data-gallery-thumb]');
  thumbs.forEach(function(button){
    button.addEventListener('click',function(){activateGallery(gallery,button.dataset.galleryTarget)});
  });
}
function initStoreSection(root){
  if(root.matches&&root.matches('[data-buy-box]'))initBuyBox(root);
  root.querySelectorAll('[data-buy-box]').forEach(initBuyBox);
  if(root.matches&&root.matches('[data-product-gallery]'))initGallery(root);
  root.querySelectorAll('[data-product-gallery]').forEach(initGallery);
}
initStoreSection(document);
if(typeof document.addEventListener==='function'){
  document.addEventListener('shopify:section:load',function(event){
    if(event.target&&typeof event.target.querySelectorAll==='function')initStoreSection(event.target);
  });
}
